import React, { useState } from 'react';
import clsx from 'clsx';
import { Button, Container, Modal, ModalProps } from 'react-bootstrap';
import CloseRoundIcon from '../styles/assets/icons/CloseButton';
import styles from './InfoModal.module.scss';

interface Props {
  heading?: React.ReactNode;
  children?: React.ReactNode;
  show?: boolean;
  size?: ModalProps['size'];
  closeModal?: () => void;
  footer?: React.ReactNode;
  center?: boolean;
  scrollable?: boolean;
  className?: string;
  testId?: string;
}

const InfoModal = ({
  heading,
  children,
  show,
  size,
  closeModal,
  footer,
  center = true,
  scrollable = true,
  className,
  testId }: Props) => {
  const [scroll, setScroll] = useState(false);

  const closeHandler = () => {
    // eslint-disable-next-line no-unused-expressions
    closeModal && closeModal();
    setScroll(false);
  };

  return (
    <Modal
      show={show}
      size={size}
      contentClassName={clsx(styles.modal, 'border-0 rounded-1', className)}
      scrollable={scrollable}
      centered={center}
      onHide={closeHandler}
      data-testid={testId}
    >
      <Modal.Header
        className={(clsx(scroll ? styles['bottom-shadow'] : 'shadow-none'), 'border-0 ps-3 ps-lg-4')}
      >
        {heading ? (
          <Modal.Title id="contained-modal-title-vcenter" className="pt-2a me-4">
            {heading}
          </Modal.Title>
        ) : null}
        {closeModal ? (
          <Button
            className={clsx(
              styles['close-btn'],
              'border-0 p-0 bg-white justify-content-end align-self-start ml-auto flex-grow-1',
            )}
            onClick={closeHandler}
            aria-label="Close Modal"
          >
            <CloseRoundIcon />
          </Button>
        ) : null}
      </Modal.Header>

      <Modal.Body
        tabIndex={0}
        className="px-3a px-lg-4 py-2a"
        onScroll={(e) => {
          setScroll((e.target as HTMLElement).scrollTop > 20);
        }}
      >
        <Container className="p-0">{children}</Container>
      </Modal.Body>

      {footer ? (
        <Modal.Footer className={styles['left-align-footer']}>{footer}</Modal.Footer>
      ) : null}
    </Modal>
)
};

export default InfoModal;
